<template>
    <div>
        <div class="border rounded-sm pt-4 pl-4 pr-4">
            <b-tabs content-class="py-5 position-relative" class="line-tabs" v-model="tabIndex" fill>
                <div class="tabs-bottom-line"></div>
                <b-tab :title="$t('application_information')">
                    <application-information-tab
                        ref="applicationInformationTab"
                        :form-data="formData"
                        @nextTab="goTap($event)"
                    />
                </b-tab>
                <!-- Reference Tab -->
                <b-tab :title="$t('reference')">
                    <reference-tab ref="referenceTab" @nextTab="goTap($event)" />
                </b-tab>
                <!-- Documents Tab (Swapped to Index 3) -->
                <b-tab :title="$t('documents')">
                    <documents-tab ref="documentsTab"  @nextTab="goTap($event)"  :form-data="formData" />
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    // Tab Components
    import ApplicationInformationTab from "../../components/admin/StoreFormTabs/ApplicationInformationTab.vue"
    import ReferenceTab from "../../components/admin/StoreFormTabs/ReferenceTab.vue"
    import DocumentsTab from "../../components/admin/StoreFormTabs/DocumentsTab.vue"
    import BisepService from "@/services/BisepService";
    // Service
    export default {
        name: 'UpdateForm',
        components: {
            ApplicationInformationTab,
            ReferenceTab,
            DocumentsTab,
        },

        data() {
            return {
                formData: {},
                tabIndex: 0
            }
        },

        methods: {
            goTap(event){
                this.redirectTab(event.currentTab)
                this.formData={
                    ...this.formData,
                    ...event.formData
                }
                if (event?.save){
                    this.savedForm()
                }
            },
            redirectTab(tab){
                this.tabIndex=tab
            },
            async savedForm() {
                const isValidApplicationInformationTab = await this.$refs.applicationInformationTab.$refs.personalInfoFormValidate.validate()
                const isValidDocumentsTab =await this.$refs.documentsTab.validate()
                if (!isValidApplicationInformationTab ) {
                    this.redirectTab(0)
                    return
                }
                if (!isValidDocumentsTab){
                    this.redirectTab(2)
                    return
                }
                try {
                    const formData =new FormData()
                    Object.entries(this.formData).forEach(([key,value])=>{
                        if (key==='references'){
                            if (value && value.length>0){
                                value.forEach((reference,key)=>{
                                    formData.append(`references[${key}][name]`,reference.name)
                                    formData.append(`references[${key}][letter]`,reference.letter)
                                    formData.append(`references[${key}][phone]`,reference.phone)
                                    formData.append(`references[${key}][surname]`,reference.surname)
                                })
                            }
                        }else if (key==='documents'){
                            if (value && Object.keys(value).length>0){
                                Object.entries(value).forEach(([key,value])=>{
                                    if (value){
                                        formData.append(`documents[${key}]`,value)
                                    }
                                })
                                }
                        }else if (key==='phone'){

                            formData.append('phone',Number(value.replace(/\s/g, "")))

                        }else{
                            formData.append(key,value)
                        }

                    })
                    const res =await BisepService.adminStore(formData)
                    this.$toast.success(this.$t('api.' + res.data.message));
                } catch (err) {

                    let forms;
                    if (err.status === 422){
                        Object.entries(err.data.errors).forEach(([key,value])=>{
                            if (Object.prototype.hasOwnProperty.call(this.$refs.applicationInformationTab.formData, key)){
                                this.redirectTab(0)
                                forms=this.$refs.applicationInformationTab.$refs.personalInfoFormValidate
                            }else if (Object.prototype.hasOwnProperty.call(this.$refs.documentsTab.localFormData.documents, key)){
                                this.redirectTab(2)
                                forms=this.$refs.documentsTab.$refs.documentFormValidate
                            }else if (key.startsWith('references')){
                                this.redirectTab(1)
                                forms=null
                            }
                        })
                    }
                    this.showErrors(err,forms)
                }
            }
        },

        watch: {
        }
    }
</script>
